import { get, post, put, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const siteService = {
  search:      (params)       => get(ENDPOINTS.sites.search, { params }),
  getById:     (id)           => get(ENDPOINTS.sites.byId(id)),
  create:      (data)         => post(ENDPOINTS.sites.list, data),
  update:      (id, data)     => put(ENDPOINTS.sites.byId(id), data),
  remove:      (id)           => del(ENDPOINTS.sites.byId(id)),
  getUsers:           (id)    => get(ENDPOINTS.sites.users(id)),
  getEffectiveUsers:  (id)    => get(ENDPOINTS.sites.effectiveUsers(id)),
  assignUser:  (data)         => post(ENDPOINTS.sites.assignUser, data),
  unassignUser:(params)       => del(ENDPOINTS.sites.unassignUser, { params }),
};
